export default __webpack_public_path__ + "static/media/dryness.1459b43b.svg";